// ./src/studentOrgs/getStudentOrgs.ts
//
// Synchronous function to retrieve static student organization data.

// Local type, constants, and utility imports.
import { latestAllStudentOrgs } from "@src/autoGenerated/latestAllStudentOrgs";
import type { StudentOrg } from "@src/schemas/StudentOrg";

export function getStudentOrgs(): StudentOrg[] {
  return latestAllStudentOrgs;
}
